import { render, staticRenderFns } from "./NavbarToggle.vue?vue&type=template&id=4815c51e"
import script from "./NavbarToggle.vue?vue&type=script&lang=js"
export * from "./NavbarToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports